import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';
import * as _ from 'lodash';

@Pipe({
  name: 'contentNews'
})
export class NewsPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.NewsEntry | Models.NewsEntry[] {
    if (!entry) {
      return null;
    }
    if (entry?.related?.entries?.length > 0) {
      const entries: Models.NewsEntry[] = entry.related.entries.map(i => this.transform(this.contentService.getEntry(i.id)) as Models.NewsEntry)
        .filter(Boolean);
      return entries.length === 0 ? null : entries;
    }

    if (!entry.detail) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }

    const news = new Models.NewsEntry();

    const firstFile = this.contentService.getFirstImageFileForEntry(entry.getId());
    let description = entry.detail.content || entry.detail.description;
    if (description === 'null') {
      description = null;
    }
    if (entry?.detail?.raw) {
      try {
        const raw = JSON.parse(entry.detail.raw);
        entry.detail = _.merge(raw, entry.detail);
      } catch (err) {
        console.warn('could not parse raw', entry.detail.raw);
      }
    }
    news.populateFromJSON({
      sourceId: entry._id, title: entry.title, description, timestamp: entry.detail.timestamp || entry.detail.date,
      url: entry.detail.url || entry.detail.bookingUrl, imageURL: firstFile ? firstFile.url : null,
      documents: this.contentService.getDocumentEntriesForEntry(entry.getId())
    });
    if (entry?.detail?.introduction !== news.description) {
      news['subtitle'] = entry?.detail?.introduction;
    }

    if (entry?.detail?.bookingText) {
      news['urlText'] = entry?.detail?.bookingTextScreen || entry?.detail?.bookingText;
    }
    if (entry.detail?.contact?.[0]?.variants?.length) {
      for (const contactVariant of entry.detail.contact[0].variants) {
        if (contactVariant.type === 'phone') {
          news['phone'] = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          news['fax'] = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          news['email'] = contactVariant.value;
        }
      }
    }
    if (entry.detail && entry.detail.location) {
      news['street'] = entry.detail.location.address;
      news['city'] = entry.detail.location.city;
      news['zip'] = entry.detail.location.zip;
      if (entry.detail.location.coordinates) {
        news['latitude'] = entry.detail.location.coordinates.latitude;
        news['longitude'] = entry.detail.location.coordinates.longitude;
      }
    }

    return news;
  }

}
